<template>
  <g>
    <Projectile v-for="event in events" :event="event" :key="event.id" @projectile-animation-done="removeProjectile" />
  </g>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import Projectile from './Projectile.vue';

export default {
  name: 'Projectiles',
  components: { Projectile },
  data: () => ({
    events: []
  }),
  methods: {
    removeProjectile(event) {
      const index = this.events.findIndex((e) => e.id === event.id);
      if (index === -1) return;
      const arrCp = [...this.events];
      arrCp.splice(index, 1);
      this.setEvents(arrCp);
    },
    setEvents(newEventsArray) {
      // dedupe and limit the events array
      const uniqueEventsById = [...new Map(newEventsArray.map((e) => [e.id, e])).values()];
      if (uniqueEventsById.length > 50) {
        uniqueEventsById.splice(50, uniqueEventsById.length - 50);
      }
      this.events = uniqueEventsById;
    }
  },
  computed: {
    ...mapGetters({
      attacksByCurrentTs: 'eventStore/attacksByTimestamp',
      projectileByCid: 'mapStore/getProjectileToHuById',
      getIdByCId: 'mapStore/getIdByCId',
      availableCountries: 'mapStore/availableCountries'
    }),
    ...mapState({
      eventColors: (state) => state.curveColors
    })
  },
  watch: {
    attacksByCurrentTs(newAttacks) {
      if (!newAttacks) return;
      if (newAttacks?.length !== 0) {
        const newAttackWithData = [];

        newAttacks.forEach((a) => {
          // there are rare cases when the geocode is not present in the map
          // an example for this is HK (Hong Kong)
          const projectilePath = this.projectileByCid(this.getIdByCId(a.geocountry));
          if (projectilePath) {
            newAttackWithData.push({
              ...a,
              projectiles: projectilePath,
              id: `${a.geocountry}_${a.timestamp}_${a.type}`,
              color: this.eventColors[a.type]
            });
          }
        });
        this.setEvents([
          ...this.events,
          ...newAttackWithData
        ]);

        // there is a rare case where the same id can appear multiple times
        // we have to trim those out
        // const usedIds = newEvents.map((o) => o.id);
        // newEvents.reverse();
        // for (let i = 0; i < newAttacks.length; i++) {
        //   if (!usedIds.includes(newAttacks[i].id)) {
        //     const atck = newAttacks[i];
        //     newEvents.push({
        //       ...atck,
        //       projectiles: this.projectileByCid(this.getIdByCId(atck.geocountry)),
        //       id: `${atck.geocountry}_${atck.timestamp}_${atck.type}`,
        //       color: this.eventColors[atck.type]
        //     });
        //   }
        // }
        // newEvents.reverse();

        // // for performance reasons we limit the max concurrent projectile
        // if (newEvents.length > 50) {
        //   newEvents.splice(0, 40);
        // }

        // this.setEvents(newEvents);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
